module.exports = __webpack_public_path__ + "static/media/BannerRegistroES.4492e9ab.jpg";